module.exports = __webpack_public_path__ + "static/media/1a_website_logo_org_emsd.ae337eea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/1a_website_logo_org_emsd.jpg
// module id = 37
// module chunks = 0